import bidShowComponent from './bid-show.component';

const bidShowModule = angular.module('bidShow', [
])
  .component('bidShow', bidShowComponent)
  .name;

export default bidShowModule;
